export default __webpack_public_path__ + "static/media/people.c6afc923.jpeg";